import { CountrySettings, GeneralCountriesApi, TravelQuestion } from 'api/general-countries';
import { CountryApprovalRequirement } from 'api/swagger/ApiClient';
import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { tryExecute } from 'framework/error_handling/error-utils';
import { ServiceBase } from 'support/base_classes/service-base';
import * as E from 'support/errors';

@autoinject
export class SafetyService extends ServiceBase {
  countrySettings: Map<number, CountrySettings> = new Map<number, CountrySettings>();
  travelQuestions: TravelQuestion[] = [];

  constructor(private api: GeneralCountriesApi, private ea: EventAggregator) {
    super();
  }

  protected async initializeService() {
    await this.reload();
    this.ea.subscribe('settings-changed', () => this.refresh());
    setInterval(() => this.refresh(), 120000);
  }

  private refresh() {
    return tryExecute(() => this.reload(), E.SERVICE_RELOAD_MESSAGE, E.SERVICE_RELOAD_TITLE, true);
  }

  async reload() {
    const [countrySettings, travelQuestions] = await Promise.all([this.api.getCountrySettings(), this.api.getTravelQuestions()]);
    this.countrySettings = new Map<number, CountrySettings>(countrySettings.map(s => [s.id, s]));
    this.travelQuestions = travelQuestions;
  }

  getApplicableQuestions(countryIds: number[]) {
    const countryQuestionIds = countryIds.map(id => this.countrySettings.get(id)).filter(s => s != null).flatMap(i => i.questionIds);
    return this.travelQuestions.filter(q => q.global || countryQuestionIds.includes(q.id)).sort((a, b) => a.message.localeCompare(b.message));
  }
}

export function aprovalRequired(approvalRequirementValue: CountryApprovalRequirement | null | undefined, transit: boolean) {
  return approvalRequirementValue === CountryApprovalRequirement.IsRequired || approvalRequirementValue === CountryApprovalRequirement.ExceptTransit && !transit;
}
